import { startsWith } from 'lodash'
import { InvoiceRule } from '../store/rules/rule.model'

export function getRuleEvent(rule: InvoiceRule) {
  return startsWith(rule.event, 'time') ? 'time' : rule.event
}
